import React, { useContext } from 'react'
import YoutubePlayer from '../Youtube'
import VideoPlayer from "../../components/VideoPlayer";
import { MyContext } from "../../PageRouters/layouts/publicLayout";
const PopupPlayer = ({ isPlayer, url, audioUrl, isAudio, isAudioPoster, handleClose }) => {
    console.log('isAudio', isAudio)
    const context = useContext(MyContext);
    // console.log('props', props)
    return (
        <>

            {
                isPlayer === "live" ? <VideoPlayer
                    // handleClose={handleClose}
                    width={"100%"}
                    height={"100vh"}
                    aws={[]}
                    videoUrl={url}
                    isPlayer={"live"}
                    playedDuration={0}
                    setConfig={false}
                    hideSeekbar={true}
                    audioUrl={audioUrl}
                    isAudio={isAudio}
                    isAudioPoster={isAudioPoster}
                // isAudio={"https://d29ij00yw17rar.cloudfront.net/shalomtv/content/s_q85jcsnd/128.m3u8"}
                /> : ''
            }
            {
                isPlayer === "youtube" ? <YoutubePlayer
                    url={url}

                    playeris={"youtube"} /> : ''
            }
        </>
    )
}

export default PopupPlayer